/*
 * Copyright (c) 2020, Matthew T. Kaufman
 */

import * as firebase from "firebase/app";
import 'firebase/auth';
import 'firebase/firestore';
import * as firebaseui from "firebaseui";

var firebaseConfig = {
    apiKey: "AIzaSyAnzF6FGO6ZXmsgTclDh0LUNnFozQUMVKI",
    authDomain: "auth.scanrad.io",
    databaseURL: "https://scanradio-241321.firebaseio.com",
    projectId: "scanradio-241321",
    storageBucket: "scanradio-241321.appspot.com",
    messagingSenderId: "893306079334",
    appId: "1:893306079334:web:11c83abbc2330c6df1c5a7",
    measurementId: "G-ZGDZ9JEDVG"
};

firebase.initializeApp(firebaseConfig);
//firebase.analytics();

export default {
    auth: firebase.auth(),
    db: firebase.firestore(),
    uiConfig: {
        signInOptions: [
            firebase.auth.GoogleAuthProvider.PROVIDER_ID,
            firebase.auth.EmailAuthProvider.PROVIDER_ID
        ],
        credentialHelper: firebaseui.auth.CredentialHelper.GOOGLE_YOLO,
        callbacks: {
            signInSuccessWithAuthResult: (result) => {
                const successResponse = async() => {
                    // go get user from webapi
                    // then update UI
                }
                console.log("signInSuccessWithAuthResult "+result)
                successResponse()

                return false
            }
        }
    },
    login() {

        let ui = firebaseui.auth.AuthUI.getInstance();
        if (!ui) {
            ui = new firebaseui.auth.AuthUI(firebase.auth());
        }

        ui.start('#firebaseui-auth-container', this.uiConfig);
    },
    logout() {
        firebase.auth().signOut()
            .then(function() {})
            .catch(function(error) {
                console.log(error)});
    },
    async getCustomClaimRole() {
        await firebase.auth().currentUser.getIdToken(true);
        const decodedToken = await firebase.auth().currentUser.getIdTokenResult();
        return decodedToken.claims.stripeRole;
    }

}

